<template>
  <d-col lg="12">
    <div class="form-group">
      <label for="responsableId"
        ><b>{{ $t("structure.form.subtitle.in.charge") }}</b></label
      >
      <!-- This component is downloaded and modified -->
      <vue-bootstrap-typehead
        id="responsableId"
        ref="responsableTypeHead"
        :value="search"
        :data="filteredInChargeUsers"
        :minMatchingChars="0"
        :serializer="serialize"
        :sanitize="false"
        @hit="selectInCharge"
      ></vue-bootstrap-typehead>
    </div>

    <div class="mt-3">
      <h6>{{ $t("structure.form.in.charge.list") }}</h6>
      <d-list-group flush class="list-group-small pb-1">
        <d-list-group-item
          v-for="(item, id) in selectedInCharge"
          :key="id"
          class="d-flex pb-2 px-1 pt-2 p-1 justify-content-between"
          :class="{ 'border-top': id > 0 }"
        >
          <span class="text-semibold text-fiord-blue">
            <i class="mr-1">N+{{ selectedInCharge.length - id }}</i>
            <i
              @click="changeOrder(id, -1)"
              class="fa fa-arrow-up mr-2 cursor-pointer"
              :class="{ 'inactive-dot': id === 0 }"
            ></i>
            <i
              @click="changeOrder(id, +1)"
              class="fa fa-arrow-down mr-2 cursor-pointer"
              :class="{ 'inactive-dot': id === selectedInCharge.length - 1 }"
            ></i>
            <i class="fa fa-user icon-rond mr-2"></i> {{ item.lastName }}
            {{ item.firstName }}
          </span>
          <span @click="removeInCharge(item)"
            ><i
              class="fa fa-trash icon-rond"
              style="color: #b6000a; cursor: pointer"
            ></i
          ></span>
        </d-list-group-item>
      </d-list-group>
    </div>
  </d-col>
</template>

<script>
import VueBootstrapTypehead from '../../layout/Typeahead/VueBootstrapTypeahead';
import GroupsHelper from '../../../helper/GroupsHelper';

export default {
  name: 'InChargeSelector',
  components: { VueBootstrapTypehead },
  props: {
    excludeReference: {
      type: String,
    },
  },
  data() {
    return {
      search: '',
      inChargeUsers: [],
      selectedInCharge: [],
    };
  },
  computed: {
    filteredInChargeUsers() {
      return this.inChargeUsers.filter(user =>
        this.selectedInCharge.find(u =>
          u.reference === user.reference ||
              u.userReference === user.reference) === undefined && this.excludeReference !== user.reference);
    },
  },
  mounted() {
    this.$services.user.findAllInCharge().then(({ data }) => {
      this.inChargeUsers = data;
    });
  },
  methods: {
    serialize(user) {
      return `${user.lastName} ${user.firstName} - ${GroupsHelper.userGroup(
        user.permissions.sort((p, p2) =>
          (p.groupReference > p2.groupReference ? -1 : 1)),
        'smallPill mb-1',
      )}`;
    },
    setInCharge(selectedInCharge) {
      this.selectedInCharge = selectedInCharge;
    },
    selectInCharge(user) {
      this.$refs.responsableTypeHead.inputValue = '';
      this.search = '';
      this.selectedInCharge.push(user);
      this.emitValues();
    },
    removeInCharge(user) {
      const index = this.selectedInCharge.findIndex(inCharge =>
        (user.reference || user.userReference) ===
          (inCharge.reference || inCharge.userReference));
      this.selectedInCharge.splice(index, 1);
      this.emitValues();
    },
    emitValues() {
      const data = this.selectedInCharge.map((user, index) => ({
        order: index + 1,
        userReference: user.reference || user.userReference,
        firstName: user.firstName,
        lastName: user.lastName,
      }));
      this.$emit('updateInCharge', data);
    },
    changeOrder(index, order) {
      if (
        (index === 0 && order === -1) ||
        (index === this.selectedInCharge.length - 1 && order === 1)
      ) {
        return;
      }
      const tmpOrder = this.selectedInCharge[index];
      this.selectedInCharge.splice(index, 1);
      this.selectedInCharge.splice(index + order, 0, tmpOrder);
      this.emitValues();
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
.inactive-dot {
  color: #dedede;
  cursor: default;
}
.icon-rond {
  background-color: white;
  border-radius: 50%;
  font-size: 11px;
  border: 1px solid rgba(128, 128, 128, 0.33);
  padding: 5px;
}
.smallPill {
  font-size: 8px;
}
</style>
